// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search-searchPageWrapper-KUcPe {
	/* background: linear-gradient(180deg, #FFFFFF 0%, var(--primary-color) 80%, var(--primary-color) 100%); */
	min-height: 100vh;
}

.Search-searchLoaderContainer-KPPHt {
	position: absolute;
	top: 30%;
	left: 0;
	right: 0;
}

.Search-searchResultContainer-Ep7pX {
	width: 100%;
	overflow-x: hidden;
	z-index: 0;
	padding-top: 176px;
	padding-bottom: 100px;
}

.Search-searchMapContainer-UPGbZ {
	width: 100%;
	position: fixed;
	right: 0;
	left: auto;
	bottom: 0;
	top: 177px;
}

.Search-mobileNavigation-Ommph {
	position: fixed;
	bottom: 13px;
	opacity: 1;
	text-align: center;
	-webkit-transition-duration: 250ms;
	        transition-duration: 250ms;
	-webkit-transition-property: opacity;
	transition-property: opacity;
	-webkit-transition-timing-function: ease-out;
	        transition-timing-function: ease-out;
	z-index: 5;
	left: 50%;
	-webkit-transform: translateX(-50%);
	    -ms-transform: translateX(-50%);
	        transform: translateX(-50%);
}

.Search-filterButton-PqEF9,
.Search-filterButton-PqEF9:hover,
.Search-filterButton-PqEF9:focus,
.Search-filterButton-PqEF9:active:focus {
	color: var(--common-primary-white-foreground);
	text-decoration: none;
	padding: 12px 24px;
	background-color: var(--common-black-primary-bg);
	-webkit-box-shadow: 0px 7px 9px var(--primary-box-shadow);
	        box-shadow: 0px 7px 9px var(--primary-box-shadow);
	border-radius: 24px;
	gap: 6px;
}

.Search-filterButtonIcons-kW2ai {
	width: 100%;
	max-width: 25px;
	height: 23px;
	min-width: 25px;
}

.Search-twoColumnLayout-LVDxv {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	height: calc(100vh - 177px);
	margin-top: 176px;
	overflow: hidden;
}

.Search-leftColumn-NC8gC {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	overflow-y: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
}

.Search-leftColumn-NC8gC::-webkit-scrollbar {
	display: none;
}

.Search-rightColumn-CBzKq {
	width: 50%;
	min-width: 500px;
	position: sticky;
	top: 0;
	height: calc(100vh - 177px);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}

.Search-resultsTitle-GkoEy {
	font-size: 32px;
	font-weight: 800;
	color: var(--secondary-oscuro);
	padding: 0 17px 0px 50px;
	margin: 0;
}

.Search-mapHeader-xQSFS {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	text-align: center;
	gap: 8px;
	font-size: 20px;
	font-weight: 800;
	color: var(--secondary-esmeralda);
	padding: 7px 16px;
}

.Search-mapHeaderIcon-SI68X {
	width: 84px;
	height: 84px;
}

.Search-mapContainer-QvEVl {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	min-height: 0;
	overflow: hidden;
	border-radius: 25px;
	/* padding: 16px; */
	margin: 16px 32px 16px 32px;
	background: var(--background-primary);
}

@media screen and (min-width: 1200px) {
	.Search-searchMapContainerShow-AhKMw {
		display: block;
		width: 100% !important;
		padding: 24px 24px 24px 24px;
	}
}

@media screen and (max-width: 1199px) {
	.Search-searchMapContainer-UPGbZ {
		display: block;
		width: 100%;
		padding: 0px;
		top: 82px;
	}

	.Search-twoColumnLayout-LVDxv {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		height: auto;
		margin-top: 0;
		overflow: visible;
	}

	.Search-leftColumn-NC8gC {
		overflow-y: visible;
	}

	.Search-rightColumn-CBzKq {
		width: 100%;
		min-width: auto;
		position: static;
		height: auto;
	}
}

@media screen and (max-width: 767px) {
	.Search-mobileNavigation-Ommph {
		bottom: 13px;
	}

	.Search-searchResultContainer-Ep7pX {
		padding-top: 263px;
	}

	.Search-rightColumn-CBzKq {
		display: none;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/search/Search.css"],"names":[],"mappings":"AAAA;CACC,0GAA0G;CAC1G,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,QAAQ;CACR,UAAU;CACV,SAAS;CACT,UAAU;AACX;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,kCAA0B;SAA1B,0BAA0B;CAC1B,oCAA4B;CAA5B,4BAA4B;CAC5B,4CAAoC;SAApC,oCAAoC;CACpC,UAAU;CACV,SAAS;CACT,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;;;;CAIC,6CAA6C;CAC7C,qBAAqB;CACrB,kBAAkB;CAClB,gDAAgD;CAChD,yDAAiD;SAAjD,iDAAiD;CACjD,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,gBAAgB;CAChB,MAAM;CACN,2BAA2B;CAC3B,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,wBAAwB;CACxB,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,kBAAkB;CAClB,QAAQ;CACR,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,2BAA2B;CAC3B,qCAAqC;AACtC;;AAEA;CACC;EACC,cAAc;EACd,sBAAsB;EACtB,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;CACV;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,aAAa;CACd;AACD","sourcesContent":[".searchPageWrapper {\n\t/* background: linear-gradient(180deg, #FFFFFF 0%, var(--primary-color) 80%, var(--primary-color) 100%); */\n\tmin-height: 100vh;\n}\n\n.searchLoaderContainer {\n\tposition: absolute;\n\ttop: 30%;\n\tleft: 0;\n\tright: 0;\n}\n\n.searchResultContainer {\n\twidth: 100%;\n\toverflow-x: hidden;\n\tz-index: 0;\n\tpadding-top: 176px;\n\tpadding-bottom: 100px;\n}\n\n.searchMapContainer {\n\twidth: 100%;\n\tposition: fixed;\n\tright: 0;\n\tleft: auto;\n\tbottom: 0;\n\ttop: 177px;\n}\n\n.mobileNavigation {\n\tposition: fixed;\n\tbottom: 13px;\n\topacity: 1;\n\ttext-align: center;\n\ttransition-duration: 250ms;\n\ttransition-property: opacity;\n\ttransition-timing-function: ease-out;\n\tz-index: 5;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n\n.filterButton,\n.filterButton:hover,\n.filterButton:focus,\n.filterButton:active:focus {\n\tcolor: var(--common-primary-white-foreground);\n\ttext-decoration: none;\n\tpadding: 12px 24px;\n\tbackground-color: var(--common-black-primary-bg);\n\tbox-shadow: 0px 7px 9px var(--primary-box-shadow);\n\tborder-radius: 24px;\n\tgap: 6px;\n}\n\n.filterButtonIcons {\n\twidth: 100%;\n\tmax-width: 25px;\n\theight: 23px;\n\tmin-width: 25px;\n}\n\n.twoColumnLayout {\n\tdisplay: flex;\n\theight: calc(100vh - 177px);\n\tmargin-top: 176px;\n\toverflow: hidden;\n}\n\n.leftColumn {\n\tflex: 1;\n\toverflow-y: auto;\n\tscrollbar-width: none;\n\t-ms-overflow-style: none;\n}\n\n.leftColumn::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.rightColumn {\n\twidth: 50%;\n\tmin-width: 500px;\n\tposition: sticky;\n\ttop: 0;\n\theight: calc(100vh - 177px);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.resultsTitle {\n\tfont-size: 32px;\n\tfont-weight: 800;\n\tcolor: var(--secondary-oscuro);\n\tpadding: 0 17px 0px 50px;\n\tmargin: 0;\n}\n\n.mapHeader {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\tgap: 8px;\n\tfont-size: 20px;\n\tfont-weight: 800;\n\tcolor: var(--secondary-esmeralda);\n\tpadding: 7px 16px;\n}\n\n.mapHeaderIcon {\n\twidth: 84px;\n\theight: 84px;\n}\n\n.mapContainer {\n\tflex: 1;\n\tmin-height: 0;\n\toverflow: hidden;\n\tborder-radius: 25px;\n\t/* padding: 16px; */\n\tmargin: 16px 32px 16px 32px;\n\tbackground: var(--background-primary);\n}\n\n@media screen and (min-width: 1200px) {\n\t.searchMapContainerShow {\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\tpadding: 24px 24px 24px 24px;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.searchMapContainer {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tpadding: 0px;\n\t\ttop: 82px;\n\t}\n\n\t.twoColumnLayout {\n\t\tflex-direction: column;\n\t\theight: auto;\n\t\tmargin-top: 0;\n\t\toverflow: visible;\n\t}\n\n\t.leftColumn {\n\t\toverflow-y: visible;\n\t}\n\n\t.rightColumn {\n\t\twidth: 100%;\n\t\tmin-width: auto;\n\t\tposition: static;\n\t\theight: auto;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mobileNavigation {\n\t\tbottom: 13px;\n\t}\n\n\t.searchResultContainer {\n\t\tpadding-top: 263px;\n\t}\n\n\t.rightColumn {\n\t\tdisplay: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchPageWrapper": `Search-searchPageWrapper-KUcPe`,
	"searchLoaderContainer": `Search-searchLoaderContainer-KPPHt`,
	"searchResultContainer": `Search-searchResultContainer-Ep7pX`,
	"searchMapContainer": `Search-searchMapContainer-UPGbZ`,
	"mobileNavigation": `Search-mobileNavigation-Ommph`,
	"filterButton": `Search-filterButton-PqEF9`,
	"filterButtonIcons": `Search-filterButtonIcons-kW2ai`,
	"twoColumnLayout": `Search-twoColumnLayout-LVDxv`,
	"leftColumn": `Search-leftColumn-NC8gC`,
	"rightColumn": `Search-rightColumn-CBzKq`,
	"resultsTitle": `Search-resultsTitle-GkoEy`,
	"mapHeader": `Search-mapHeader-xQSFS`,
	"mapHeaderIcon": `Search-mapHeaderIcon-SI68X`,
	"mapContainer": `Search-mapContainer-QvEVl`,
	"searchMapContainerShow": `Search-searchMapContainerShow-AhKMw`
};
module.exports = ___CSS_LOADER_EXPORT___;
